module.exports = __webpack_public_path__ + "static/media/COS_LE_PREPARATOIRE_PREP_APOTHICAIRE.2a771e4b.png";